import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { GeneralComponent } from '@app/modules/template/pages/general/general.component';
import { AuthGuard } from '@app/core/guards';

export enum TemplateModuleRoutes {
    TEMPLATE = 'template'
}

export const routes: Routes = [
    { path: TemplateModuleRoutes.TEMPLATE, component: GeneralComponent, canActivate: [AuthGuard] },
];

export const routing = RouterModule.forChild(routes);

@NgModule({
    imports: [routing],
    exports: [RouterModule]
})
export class TemplateRoutingModule { }
